const getDummyTextarea = () => {
  const textarea = document.createElement('textarea') as HTMLTextAreaElement;
  textarea.style.top = '0';
  textarea.style.left = '0';
  textarea.style.display = 'fixed';

  return textarea;
};

const isClipboardCommandSupported = document.queryCommandSupported('copy') ?? false;
const isClipboardSupported = navigator?.clipboard ?? false;
/**
 * https://velog.io/@otterji/navigation.share-copyClipboard
 * navigator.clipboard안 됐을때 대비 textarea를 생성해서 복사하는 방식
 */
export const copyToClipboard = (text: string) => {
  return new Promise<boolean>(async resolve => {
    if (isClipboardSupported) {
      await navigator.clipboard.writeText(text);
      resolve(true);
      return;
    }

    const rootElement = document.body;

    if (isClipboardCommandSupported) {
      const textarea = getDummyTextarea();
      textarea.value = text;

      rootElement.appendChild(textarea);

      textarea.focus();
      textarea.select();

      document.execCommand('copy');
      rootElement.removeChild(textarea);
      resolve(true);
      return;
    }

    resolve(false);
    return;
  });
};
